/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu/base-navigation-menu.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/base-menu-item.fragment';
import {BaseNavigationMenuPrimaryItemFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu-primary-item/base-navigation-menu-primary-item.fragment';

export const NavigationMenuFragment = gql`
  ${BaseLinkFragment}
  ${BaseMenuItemFragment}
  ${BaseNavigationMenuFragment}
  ${BaseNavigationMenuPrimaryItemFragment}

  fragment NavigationMenuFragment on NavigationMenu {
    ...BaseNavigationMenuFragment

    menuItemsCollection {
      items {
        __typename
        ... on MenuItem {
          ...BaseMenuItemFragment
        }
      }
    }
    menuItemsCursorCollection {
      items {
        __typename
        ... on MenuItem {
          ...BaseMenuItemFragment
        }
      }
    }
    primaryItemsCollection {
      items {
        __typename
        ... on NavigationMenuPrimaryItem {
          ...BaseNavigationMenuPrimaryItemFragment
        }
      }
    }
    primaryItemsCursorCollection {
      items {
        __typename
        ... on NavigationMenuPrimaryItem {
          ...BaseNavigationMenuPrimaryItemFragment
        }
      }
    }
    promotionalLinksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    promotionalLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
